const offline = ref(false);

if (typeof window !== "undefined") {
  window.addEventListener(
    "load",
    function () {
      offline.value = !navigator.onLine;
    },
    false,
  );

  window.addEventListener(
    "online",
    function () {
      offline.value = false;
    },
    false,
  );

  window.addEventListener(
    "offline",
    function () {
      offline.value = true;
    },
    false,
  );
}

export { offline };
